const formatDecimal = (value, decimals = 2) => {
  if (value === null || value === undefined) return 'N/D';

  return `${value.toFixed(decimals)?.replace('.', ',')}%`;
};

export default formatDecimal;
